<script>
import rpcjs from 'rpcjs';
import {getContext, setContext} from 'svelte';
import pages from './pages';
// import pages from other pacakges  here
// combine all pages
//  not used
// const allpages = {...pages};
// const {api_init, title, createUrlStore} = rpcjs.props;
// const pathprefix = $url.pathname.match(/^\/[^\/]*/).at(0);
const {title, createUrlStore} = rpcjs.props;
import Adventure from 'bhoot-svelte-components/adventure';
import LogoIcon from './logoIcon.svelte';
export let ssrUrl = '';
setContext('APP', {url: createUrlStore(ssrUrl)});
const {url} = getContext('APP');

const color1 ='#010422';
const source1 = '/images/opus_logowhite.svg';
</script>

<svelte:head>
	<title>| {$title}</title>
</svelte:head>

<main>
	<!-- {#if $api_init} -->
	<svelte:component
		this={pages[$url.pathname.match(/^\/[^\/]*/).at(0) || Adventure]}
	/>
	<!-- {/if}git d -->
	{#if $url.pathname === '/questions'}
	<LogoIcon color={color1} source={source1}/>
	{:else}
	<LogoIcon/>
	{/if}
</main>

<style>
	:global(body) {
		font-family: "Red Hat Text";
		margin: 0;
		padding: 0;
		overflow: hidden;
	}
	:global(a) {
		text-decoration: none;
		color: inherit;
	}
	:global(a:hover) {
		text-shadow: 0.1vw 0.3vw 0.2vw lightgrey;
	}
</style>
